<app-dialog [dialogWithInput]="dialog" [permissions]="permissions">
    <app-create-update-default
        #createUpdateDefaultComponent
        [formGroup]="formGroup"
        [service]="service"
        [findOneService]="findOneService"
        [id]="dialog.input.id"
        (entityLoaded)="entityLoaded($event)"
        (entitySaved)="entitySaved($event)"
        [buildPayload]="buildPayload"
        [inDialog]="true"
        [hideSaveButton]="true"
        (entitySaveErrorMessageEvent)="entitySaveError($event)">
        <ng-template template-content>

            <!-- Default -->
            <div *ngIf="partnerDefaultGroupFormGroup">
                <app-card title="Détails">
                    <div class="row">
                        <app-form-field label="Nom" [required]="true">
                            <app-input-text [parentFormGroup]="defaultGroup" parentFormControlName="name" (changedEvent)="nameUpdated(defaultGroup.get('name').value)"></app-input-text>
                        </app-form-field>
                        <app-form-field label="Identifiant TVA" *ngIf="defaultGroup.get('businessNumber')">
                            <app-input-text [parentFormGroup]="defaultGroup" parentFormControlName="businessNumber"></app-input-text>
                        </app-form-field>
                        <app-form-field label="Régime TVA" [required]="true" *ngIf="defaultGroup.get('vatRegimeValue')">
                            <app-lov-value-select-filter [parentFormGroup]="defaultGroup"
                                                         lovListName="PARTNER_VAT_REGIME"
                                                         parentFormControlName="vatRegimeValue"></app-lov-value-select-filter>
                        </app-form-field>
                    </div>
                </app-card>
                <app-card title="Contact">
                    <div class="row">
                        <app-form-field label="E-mail">
                            <app-email-input [parentFormGroup]="defaultGroup" parentFormControlName="email"></app-email-input>
                        </app-form-field>
                    </div>
                    <h2 style="margin: 8px;">Téléphones</h2>
                    <div class="row">
                        <app-form-field label="Principal">
                            <app-phone-input [parentFormGroup]="phone" #phoneComponent></app-phone-input>
                        </app-form-field>
                        <app-form-field label="GSM">
                            <app-phone-input [parentFormGroup]="mobilePhone"
                                             #mobilePhoneComponent></app-phone-input>
                        </app-form-field>
                        <app-form-field label="Bureau">
                            <app-phone-input [parentFormGroup]="officePhone"
                                             #officePhoneComponent></app-phone-input>
                        </app-form-field>
                    </div>
                    <div class="row">
                        <app-form-field label="Site internet">
                            <app-input-text [parentFormGroup]="defaultGroup" parentFormControlName="website"></app-input-text>
                        </app-form-field>
                    </div>
                </app-card>
            </div>

            <!-- Patient / Practitioner -->
            <app-card title="Informations générales" [style]="(!partnerPersonFormGroup) ? 'display: none;' : ''">
                <div class="row">
                    <app-form-field size="12">
                        <app-person-search [parentFormGroup]="defaultGroup" parentFormControlName="personId"
                                           (newItemClickEvent)="newPersonItemClick()" *ngIf="!showPersonForm"
                                           (itemSelectEvent)="personItemSelect($event)"></app-person-search>
                    </app-form-field>
                </div>
                <div class="text-right">
                    <span class="link underline"
                       (click)="showPersonForm = false" *ngIf="showPersonForm">Utiliser une personne existante</span>
                </div>
                    <app-person-update-form [parentFormGroup]="personFormGroup" [birthDateRequired]="isPatient"
                                            (nameChangedEvent)="nameUpdated($event)"
                                            #personUpdateForm
                                            [style]="!showPersonForm ? 'display: none;' : ''"></app-person-update-form>

            </app-card>

            <app-card [class]="(!displayOffice && !practitionerTypeValueFormControl && !formGroup.get('parentPartnerId')) ? 'd-none' : ''">
                <div class="row" >
                    <app-form-field [label]="(isPatient || isPractitioner) ? 'Cabinet' : 'Succursale'" [required]="true">
                        <app-office-select style="width: 100%;"
                                           parentFormControlName="officeId"
                                           [parentFormGroup]="formGroup"
                                           (officeElementsChangeEvent)="officesRefreshed($event)">
                        </app-office-select>
                    </app-form-field>

                    <ng-container *ngIf="formGroup.get('parents') as parentFormArray">
                        <app-form-field *ngFor="let control of parentFormArray.controls" [label]="control.get('label')?.value">
                            <app-partner-search *ngIf="control.get('partnerTypeValue')?.value === PartnerType.PARTNER_TYPE_CARE_HOME"
                                                [value]="control.get('partner')?.value"
                                                [parentFormGroup]="control"
                                                parentFormControlName="partnerId"
                                                [typeValue]="control.get('partnerTypeValue')?.value">
                            </app-partner-search>
                            <app-partner-search-with-create-ability *ngIf="control.get('partnerTypeValue')?.value !== PartnerType.PARTNER_TYPE_CARE_HOME"
                                                                    [value]="control.get('partner')?.value"
                                                                    [parentFormGroup]="control"
                                                                    parentFormControlName="partnerId"
                                                                    [typeValue]="control.get('partnerTypeValue')?.value">
                            </app-partner-search-with-create-ability>
                        </app-form-field>
                    </ng-container>
                    <app-form-field size="12" label="Fonction" [required]="true" *ngIf="practitionerTypeValueFormControl">
                        <app-lov-value-select-filter [parentFormGroup]="formGroup"
                                                     parentFormControlName="practitionerTypeValue"
                                                     lovListName="PRACTITIONER_TYPE"
                                                     (lovValuesElementChangeEvent)="practitionerTypesChanged($event)"></app-lov-value-select-filter>
                    </app-form-field>
                </div>
            </app-card>
            <app-card title="Provenance" *ngIf="formGroup.get('marketingChannels')">
                <p class="text-body">Mentionnez ici par quel(s) moyen(s) le patient vous a connu (Site Internet,
                        Doctolib, Facebook, ect...). Vous pouvez ajouter des provenances <a
                                (click)="redirectTo('app/marketing/channels')">ici</a></p>
                <app-patient-channels style="display: block; width:100%;" [parentFormGroup]="formGroup"></app-patient-channels>
            </app-card>

            <h3 *ngIf="maxNbAddresses === 1">Adresse</h3>
            <h3 *ngIf="maxNbAddresses !== 1">Adresses</h3>
            <app-form-array-input [parentFormGroup]="formGroup"
                                  parentFormControlName="addresses"
                                  [buildNewItemForm]="newAddress"
                                  [maxElementSize]="maxNbAddresses"
                                   addItemLabel="Une adresse">
                <ng-template template-content let-itemFormGroup='itemFormGroup' let-index= 'index'>
                    <app-card [hasRawTitle]="true">
                        <app-button buttons iconName="copy" tooltip="Copier depuis l'adresse précédente" *ngIf="index > 0" (clickEvent)="copyAddress(index -1, index)"></app-button>

                        <div class="row" *ngIf="allowedAddressTypes.length > 1">
                            <app-form-field label="Type" [required]="true" [size]="12">
                                <app-lov-value-select-filter [parentFormGroup]="itemFormGroup"
                                                             parentFormControlName="typeValue"
                                                             lovListName="PARTNER_ADDRESS"></app-lov-value-select-filter>
                            </app-form-field>
                        </div>
                        <app-edit-address
                                [country]="country" [inCard]="false"
                                [entity]="itemFormGroup.get('initialAddress').value"
                                [parentFormGroup]="itemFormGroup"></app-edit-address>
                        <div class="row" *ngIf="maxNbAddresses !== 1">
                            <app-form-field label="Libellé" [size]="12">
                                <app-input-text parentFormControlName="label" [parentFormGroup]="itemFormGroup"></app-input-text>
                            </app-form-field>
                        </div>
                    </app-card>

                </ng-template>
            </app-form-array-input>

            <!-- <app-edit-address
                    [style]="!partnerAddressFormGroup ? 'display: none;' : ''"
                    [country]="country" [inCard]="true"
                    [parentFormGroup]="addressFormGroup" #editAddress></app-edit-address>-->

            <div class="m-t-20">
                <app-card title="Note">
                    <div class="col-12">
                        <app-form-field [size]="12" [sizeLg]="12" [sizeXl]="12">
                            <app-rich-text-editor [parentFormGroup]="formGroup" parentFormControlName="note"></app-rich-text-editor>
                        </app-form-field>
                    </div>
                </app-card>
            </div>
        </ng-template>

    </app-create-update-default>

    <ng-container dialog-actions>
        <app-button (click)="createUpdateDefaultComponent.save()"
                    [loading]="createUpdateDefaultComponent.saveLoading"
                    [disabled]="!formGroup.valid" fill="solid" color="primary"
                    iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>



